<template>
    <div>
       <p class="text-danger font-weight-bold">Note: Please do not apply for this position if you have less than 3 years experience and your expected salary is more than 6 LPA*</p>
        <form id="careerForm" class="needs-validation" action="#">
            <div id="resp-msg" class="text-danger my-2 p-2 d-none"></div>
            <div class="form-row">
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group is-floating-label required-item">
                        <input type="text" name="name" id="name" placeholder="Name" v-model="name"
                            class="form-control field namevalidation text-dark contact-us__input"
                            :class="nameError ? 'is-invalid' : ''" />
                        <div class="invalid-feedback">
                            {{nameError}}
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group is-floating-label required-item">
                        <input type="text" name="phone" id="phone" v-model="phoneNumber" placeholder="Phone"
                            class="form-control field phonevalidation text-dark contact-us__input"
                            :class="phoneError  ? 'is-invalid' : ''" />
                        <div class="invalid-feedback">
                            {{ phoneError }}
                        </div>
                    </div>
                </div>
            </div>
            <!--/form-row-->

            <div class="form-row">
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group is-floating-label required-item">
                        <input type="email" name="email" v-model="emailAddress" id="career_email" placeholder="Email"
                            class="form-control field emailvalidation text-dark contact-us__input"
                            :class="emailError ? 'is-invalid' : ''" />
                        <div class="invalid-feedback">
                            {{ emailError }}
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group position-relative required-item">
                        <select id="position" name="position" v-model="jobPosition" class="form-control"
                            :class="jobPositionError ? 'is-invalid' : ''">
                            <option :value="''">Choose Position...</option>
                            <option v-for="(item, index) in jobPositionsList" :key="'job-item-'+index" :value="item">
                                {{ item }}</option>
                        </select>
                        <div class="invalid-feedback">
                            {{ jobPositionError }}
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group is-floating-label required-item">
                        <input type="number" name="years_of_experience" v-model="years_of_experience" id="years_of_experience" placeholder="Years of experience"
                            class="form-control field years_of_experiencevalidation text-dark contact-us__input"
                            :class="years_of_experienceError ? 'is-invalid' : ''" />
                        <div class="invalid-feedback">
                            {{ years_of_experienceError }}
                        </div>
                    </div>
                </div>
            </div>
            <!--/form-row-->

            <div class="form-row">
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group is-floating-label required-item">
                        <input type="text" name="current_salary" id="current_salary" placeholder="Current Salary (CTC) in LPA"
                            v-model="current_salary"
                            class="form-control field current_salaryvalidation text-dark contact-us__input"
                            :class="current_salaryError ? 'is-invalid' : ''" />
                        <div class="invalid-feedback">
                            {{current_salaryError}}
                        </div>
                    </div>
                </div>
                  <div class="col-sm-12 mb-sm-2">
                  <div class="form-group is-floating-label required-item">
                    <input
                      type="number"
                      name="expected_salary"
                      id="expected_salary"
                      v-model="expected_salary"
                      placeholder="Expected Salary (CTC) in LPA"
                      class="form-control field expected_salaryvalidation text-dark contact-us__input"
                      :class="expected_salaryError  ? 'is-invalid' : ''"
                    />
                    <div class="invalid-feedback">
                      {{ expected_salaryError }}
                    </div>
                  </div>
                </div>
            </div>
            <!--/form-row-->

            <div class="form-row">
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group position-relative required-item">
                        <select id="can_join" name="can_join" v-model="can_join" class="form-control"
                            :class="can_joinError ? 'is-invalid' : ''">
                            <option :value="''">Choose your availability...</option>
                            <option v-for="(item, index) in can_joinList" :key="'join-'+index" :value="item">{{ item }}
                            </option>
                        </select>
                        <div class="invalid-feedback">
                            {{ can_joinError }}
                        </div>
                    </div>
                </div>
            </div>
            <!--/form-row-->
            <div class="form-row">
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group position-relative required-item">
                      <small class="text-center">Choose Preferred Interview Date</small>
                       <input type="date" name="date" v-model="dateAvailable" id="career_date_vailable" placeholder="Select interview date"
                            class="form-control field text-dark contact-us__input"
                            :class="dateAvailableError ? 'is-invalid' : ''" />
                        <div class="invalid-feedback">
                            {{ dateAvailableError }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group position-relative required-item">
                      <select id="time" name="time" v-model="timeAvailable" class="form-control"
                            :class="timeAvailableError ? 'is-invalid' : ''">
                            <option :value="''">Choose Preferred Interview Time...</option>
                            <option v-for="(item, index) in timeAvailableList" :key="'time-item-'+index" :value="item">
                                {{ item }}</option>
                        </select>
                        <div class="invalid-feedback">
                            {{ timeAvailableError }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col-sm-12 mb-sm-2">
                    <div class="form-group mb-1 is-floating-label">
                        <textarea type="text" name="cover_note" id="cover_note" rows="15" placeholder="Cover Note"
                            v-model="coverNote" class="form-control field text-dark contact-us__input"></textarea>
                        <div class="invalid-feedback text-left">Please enter your Cover Note</div>
                    </div>
                    <div class="form-text text-muted">
                        <i class="fas fa-info-circle mr-1"></i>
                        <small>Tell us about your experience</small>
                    </div>
                </div>
            </div>
            <!--/form-row-->

            <div class="form-row">
                <div class="col-sm-12 mb-sm-2">
                    <div class="custom-file">
                        <input type="file" name="file" class="custom-file-input contact-us__input" id="customFile"
                            @change="fileChangeHandler" />
                        <label class="custom-file-label" for="customFile">Upload Resume</label>
                    </div>
                    <div class="form-text text-muted">
                        <i class="fas fa-info-circle mr-1"></i>
                        <small>Max file size - 5 MB. Allowed formats - pdf, doc, docx.</small>
                    </div>
                    <div class="invalid-feedback" :style="{display: resumeError ? 'block' : 'none'}">
                        Please attach a valid file for your resume
                    </div>
                </div>
            </div>
            <!--/form-row-->

            <div class="mt-3">
                <button class="button_layout" type="buuton" @click.prevent="postJobApplication"
                    id="submitButton">Apply</button>
            </div>
        </form>
        <div class="new_banner_content_box mt-5" v-if="isLoading">
            <div class="mb-4 mb-md-5 text-center">
                <img src="https://www.redbuyers.com/images/loader/Spin-1s-200px.gif" width="50" alt="" />
                <span class="pl-2 font-weight-bold" style="font-size: 20px">Please Wait!</span>
            </div>
        </div>
        <div v-else>
        </div>
    </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  maxLength,
  helpers
} from "vuelidate/lib/validators";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
export default {
  name: "CareersForm",
  data() {
    return {
      name: "",
      phoneNumber: "",
      emailAddress: "",
      formAttachment: "",
      jobPosition: "",
      current_salary: "",
      expected_salary: "",
      can_join: "",
      coverNote: "",
      isLoading: false,
      jobPositionsList: [
        // "UI UX Designer",
        // "Staff Product Designer",
        // "Senior Software Engineer",
        // "Backend Developer - Laravel",
        // "Senior Software Engineer - Mobile",
        // "Associate, Growth Finance and Strategy",
        "Frontend Developer - React.js",
        // "Associate General Counsel - Product"
        // "Sales and Marketing"
      ],
      can_joinList: [
        "Immediate",
        "Less than 15 days",
        "15-30 days",
        "More than 30 days"
      ],
      dateAvailable:"",
      timeAvailable:"",
      timeAvailableList:[
        "6:00 PM - 7:00 PM IST",
        "7:00 PM - 8:00 PM IST",
        "8:00 PM - 9:00 PM IST",
        "9:00 PM - 10:00 PM IST",
        "10:00 PM - 11:00 PM IST",
        "11:00 PM - 12:00 AM IST",
        "12:00 AM - 01:00 AM IST",
        "01:00 AM - 02:00 AM IST",
      ],
      years_of_experience: "",
    };
  },
  methods: {
    fileChangeHandler(event) {
      let file = event.target.files[0];
      let fileSize = file.size / 1024 / 1024;
      let allowedFileSize = 5;
      let fileType = file.type;
      let allowedFileTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ];
      if (allowedFileTypes.includes(fileType)) {
        if (fileSize <= allowedFileSize) {
          this.formAttachment = file;
          $(".custom-file-label").text(file.name);
        } else {
          alert("File size must be less than or equal to 5 MB.");
        }
      } else {
        alert("File type is not allowed.");
      }
    },
    postJobApplication() {
      this.$v.$touch();
      if(this.formInvalid) return
        this.submitJobApplication();
    },
    submitJobApplication() {
      this.isLoading = true;
      const formData = new FormData();

      formData.append("name", this.name);
      formData.append("phone", this.phoneNumber);
      formData.append("email", this.emailAddress);
      formData.append("position", this.jobPosition);
      formData.append("current_salary", this.current_salary);
      formData.append("expected_salary", this.expected_salary);
      formData.append("can_join", this.can_join);
      formData.append("date", this.dateAvailable);
      formData.append("time", this.timeAvailable);
      formData.append("cover_note", this.coverNote);
      formData.append("resume", this.formAttachment);
      formData.append("years_of_experience", this.years_of_experience);
      const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
      }

      axios.post('/submit-job-application', formData, config)
      .then(res => {
        this.isLoading = false;
        this.name = "";
        this.emailAddress = "";
        this.phoneNumber = "";
        this.jobPosition = "";
        this.current_salary = "";
        this.expected_salary = "";
        this.can_join = "";
        this.dateAvailable = "";
        this.timeAvailable = "";
        this.coverNote = "";
        this.formAttachment = "";
        this.years_of_experience = "";
        this.$v.$reset()
        $(".custom-file-label").text("Upload Resume");
        let msg = "Application Submitted";
        if(res?.data?.message) {
          msg = res.data.message;
        }
        //alert(msg);
        Swal.fire({
          title: msg,
          icon: "success",
          confirmButtonText: "Okay",
          timer: 5000
        });
      })
      .catch(error => {
        this.isLoading = false;
          const restObj = {}
          if(error?.response?.data?.errors) {
            restObj.html = ''
            Object.values(error?.response?.data?.errors)?.forEach((err)=>{
              restObj.html+=`<p style="color:red">${err[0]}</p>`
            })
          }
          if (error?.response?.data?.message) {
            Swal.fire({
            title: error?.response.data.message,
            icon: "error",
            timer: 3000,
            ...restObj
            });
          }
      });
    },
  },
  computed: {
    formInvalid() {
      if(this.$v.$invalid) {
        return true;
      } else {
        return false;
      }
    },
    nameError(){
      if (this.$v.name.$error) {
        return "Name cannot be empty";
      } else {
        return '';
      }
    },
    emailError(){
      if (this.$v.emailAddress.$error) {
        if (!this.$v.emailAddress.required) {
          return "Email is required";
        } else if (!this.$v.emailAddress.email) {
          return "Please enter a valid email address";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    phoneError(){
      if(this.$v.phoneNumber.$error) {
        if(!this.$v.phoneNumber.required) {
          return 'Phone number is required';
        } else if(!this.$v.phoneNumber.minLength || !this.$v.phoneNumber.maxLength) {
          return 'Phone number must be a 10 digit number';
        } else {
          return "Please enter a valid phone number";
        }
      }
      return ""
    },
    jobPositionError(){
      if(this.$v.jobPosition.$error)
        return "Please choose a position that you are applying for";
      return ""
    },
    current_salaryError(){
      if(this.$v.current_salary.$error)
        return "Please enter your current salary";
      return ""
    },
    expected_salaryError(){
      if(this.$v.expected_salary.$error)
        return "Please enter your expected salary";
      return ""
    },
    can_joinError(){
      if(this.$v.can_join.$error)
        return "Please choose your availability";
      return ""
    },
    resumeError(){
      if(this.$v.formAttachment.$error) {
      return "Please attach a valid file for your resume"
      }
      return ""
    },
    dateAvailableError(){
      if(this.$v.dateAvailable.$error) {
      return "Select interview date"
      }
      return ""
    },
    timeAvailableError(){
      if(this.$v.timeAvailable.$error) {
      return "Select interview date"
      }
      return ""
    },
    years_of_experienceError(){
      if(this.$v.years_of_experience.$error)
        return "Please enter your experience ";
      return ""
    },
  },
  validations: {
    name: {
      required
    },
    emailAddress: {
      required,
      email
    },
    phoneNumber: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10)
    },
    jobPosition: {
      required
    },
    current_salary:{
      required
    },
    expected_salary:{
      required
    },
    can_join: {
      required
    },
    dateAvailable: {
      required
    },
    timeAvailable: {
      required
    },
    formAttachment:{
      required,
      attachmentRule:(value) =>{
        console.log("Value",value)
        return value && helpers.regex(value?.type, /\.(pdf|doc?s)$/)
      }
    },
    years_of_experience:{
      required
    } 
  }
};
</script>

<style>
.button_layout {
    background-color: #E11F26;
    color: white;
    padding-block: 0.75rem;
    padding-inline: 1rem;
    border-radius: 0.65rem;
    -webkit-border-radius: 0.65rem;
    -moz-border-radius: 0.65rem;
    -ms-border-radius: 0.65rem;
    -o-border-radius: 0.65rem;
    border: none;
    width: 100%;
}

.button_layout:hover {
    color: #E11F26;
    background-color: white;
    outline: 1px solid #E11F26 !important;
}
</style>
